import { render, staticRenderFns } from "./ui-frame-bg.vue?vue&type=template&id=16e13a02&scoped=true&"
import script from "./ui-frame-bg.vue?vue&type=script&lang=js&"
export * from "./ui-frame-bg.vue?vue&type=script&lang=js&"
import style0 from "./ui-frame-bg.vue?vue&type=style&index=0&id=16e13a02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e13a02",
  null
  
)

export default component.exports